module.exports = __webpack_public_path__ + "img/BlackVisaCard.d99d68db.png";